import { createAction } from "redux-actions";
import { createSelector } from "reselect";
import { path, pathOr, prop, identity } from "ramda";

import {
  selectDlsActiveCategoryTitle,
  selectDlsActiveTab,
  setDlsActiveCategory
} from "~/store/ducks/user/uistate";

export const SET_CURRENT_PAGE = "DOMAIN@UI/EMBEDDED::SET_CURRENT_PAGE";
export const CLEAR_PAGESTORE_PAGE = "DOMAIN@UI/EMBEDDED::CLEAR_PAGESTORE_PAGE";

export const setCurrentPage = createAction(SET_CURRENT_PAGE);
export const clearPagestorePage = createAction(CLEAR_PAGESTORE_PAGE);

export const setDlsActiveCategoryAndPage = categoryAndPage => (
  dispatch,
  getState
) => {
  const activeTab = selectDlsActiveTab(getState());
  const [categoryTitle, currentPage] = categoryAndPage.split("::");
  dispatch(setDlsActiveCategory(categoryTitle));
  dispatch(setCurrentPage({ categoryTitle, currentPage, activeTab }));
};

const getEmbedded = path(["domain", "ui", "embedded"]);

export const selectEmbedded = createSelector(getEmbedded, identity);

export const selectPageStore = createSelector(
  selectEmbedded,
  prop("pageStore")
);

export const selectCurrentPageForActiveCategory = createSelector(
  selectPageStore,
  selectDlsActiveCategoryTitle,
  (pageStore, categoryTitle) =>
    pathOr(1, ["currentPage"], pathOr({}, [categoryTitle], pageStore))
);

export const selectDlsActiveCategoryTitleAndPage = createSelector(
  selectDlsActiveCategoryTitle,
  selectCurrentPageForActiveCategory,
  (title, page) => `${title}::${page}`
);

const initialState = () => ({
  pageStore: {}
});

export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    case SET_CURRENT_PAGE:
      const { categoryTitle, currentPage, activeTab } = action.payload;
      return {
        pageStore: {
          ...state.pageStore,
          [categoryTitle]: {
            currentPage: parseInt(currentPage),
            activeTab
          }
        }
      };
    case CLEAR_PAGESTORE_PAGE:
      return {
        pageStore: Object.keys(state.pageStore)
          .filter(key => state.pageStore[key].activeTab !== "page")
          .map(key => ({ [key]: state.pageStore[key] }))
      };
    default:
      return state;
  }
}
